/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Remove_Member_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to remove member from the team. Please try again." |
*
* @param {Teams_Remove_Member_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_remove_member_error = /** @type {((inputs?: Teams_Remove_Member_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Remove_Member_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Entfernen des Mitglieds aus dem Team. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to remove member from the team. Please try again.")
});